import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { ReactComponent as SendIcon } from '../../../../../assetsNew/icons/paper-airplane.svg';
import { ReactComponent as CheckIcon } from '../../../../../assetsNew/icons/check-circle.svg';
import { removeBatchMessageStatus } from '../../../../../sagas/batchMessage/actions';

import './_successItem.scss';

const SuccessItem = ({ item }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      dispatch(removeBatchMessageStatus({ id: item.id }));
    }, 5000);
  }, []);

  return (
    <div className="successItem">
      <div className="successItem-status">
        <SendIcon />
        <p className="successItem-status__label">Messages have been sent</p>
      </div>
      <div className="successItem-check">
        <CheckIcon />
      </div>
    </div>
  );
};

SuccessItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.any,
    status: PropTypes.string
  })
};

export default SuccessItem;
